import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { useAuth } from '@/providers/auth/use-auth';

function RouteComponent() {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, [logout]);

  return <></>;
}

export const Route = createFileRoute('/admin/logout/')({
  component: RouteComponent,
});
